import "../css/application.css";

import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";

import { load } from "@shopify/theme-sections";

import "./components/about_slider";
import "./components/ring_gallery";
import "./components/collection_module";
import "./components/products_slider";
import "./components/wedding_module";
import "./components/announcement_bar";
import "./components/journal_module";
import "./components/ring_stories_module";
import "./components/split_screen_hero";
import "./components/info_module";
import "./components/dropdown_accordion";
import "./components/collection_page";
import "./components/product_cell";
import "./components/product_carousel";
import "./components/product_charms_form";

import Header from "./components/header";

load("*");

Header.init();

// header accordion
var acc = document.getElementsByClassName("mobile-menu-target-item");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = "100%";
    }
  });
}

//footer
function fixbtn() {
  const div = document.createElement("div");

  div.innerHTML = `
  <svg width="14" height="12" viewBox="0 0 14 12">
  <path
    d="M6,0,4.909,1.091l4.13,4.13H0V6.779H9.039l-4.13,4.13L6,12l6-6Z"
    fill="#fff"
  />
  </svg>
  `;

  // setTimeout(function () {
  // document.querySelector(".Button__FormStyledButton-p2mbjt-0").innerHTML = "";
  document
    .querySelector(
      "#shopify-section-p_footer .Button__FormStyledButton-p2mbjt-0"
    )
    .appendChild(div);
  // }, 6000);
}

$(checkForChanges);
// console.log("start");

function checkForChanges() {
  if (document.querySelector(".Button__FormStyledButton-p2mbjt-0")) {
    fixbtn();
    // console.log("IN");
  } else {
    setTimeout(checkForChanges, 500);
    // console.log("out");
  }
}

jQuery(function () {
  jQuery("#main-nav li a").each(function () {
    if (jQuery(this).attr("href") === window.location.pathname) {
      jQuery(this).addClass("current");
    }
  });
});

// if (window.location.pathname === "/") {
//   document.addEventListener("DOMContentLoaded", function () {
//     document
//       .querySelector("#hero-height .responsive-image__image")
//       .classList.add("scale-up");
//   });
// }

const bodyElement = document.querySelector("body");
$(".dropdown").hover(function () {
  $(".v-main-header").removeClass("is-inversed");
  $(".v-main-header").addClass("has-dropdown-opened");
  $(".v-main-header").removeClass("with-transitions");
  $(".dlinks").addClass("active");
  $(".dlinks").css("color", "#101E13");
  $(".currency-picker-color").css("color", "#101E13");
  $(".cartItems").css("color", "#101E13");
  $(".normal-link-menu a").css("color", "#101E13");
  // $(".normal-link-menu a").attr("style", "color: #101E13 !important");
  // $(".site-header__container").css("background-color", "white");
  //search
  $(".searchDark").css("display", "block");
  $(".searchLight").css("display", "none");
  // heart
  $("#heartDark").css("display", "block");
  $("#heartLight").css("display", "none");
  // profile
  $(".profileDark").css("display", "block");
  $(".profileLight").css("display", "none");
  // cart
  $(".cartDark").css("display", "block");
  $(".cartLight").css("display", "none");
  // logo
  $("#darkLogo").css("display", "block");
  $("#lightLogo").css("display", "none");
  // arrows
  $(".arrowDark").css("display", "block");
  $(".arrowLight").css("display", "none");
});

$("#main-nav").mouseleave(function () {
  $(".dlinks").removeClass("active");
  if (window.scrollY === 0) {
    if (bodyElement.classList.contains("template-index")) {
      $(".v-main-header").addClass("is-inversed");
    }
  }
  $(".v-main-header").removeClass("has-dropdown-opened");
});

$("._3yzgbUSnoM0g12QES3gF19").css("display", "none");
